import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/internal/operators/filter";
import { HttpStatusCode } from "../helpers/httpCode";

@Injectable({
  providedIn: "root"
})
export class PreviousRouteService {
  previousUrl: string;
  currentUrl: string;

  private _history = new Array<string>();
  private _routeKey = "routes";

  constructor(private _router: Router) {
    const routes = JSON.parse(sessionStorage.getItem(this._routeKey));

    if (routes) {
      this._history = routes;
    }

    this.currentUrl = this._router.url;

    _router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (!event.url.includes(HttpStatusCode.NotFound.toString())) {
          this.previousUrl = this.currentUrl;
          this.currentUrl = event.url;
          this._history = [...this._history, this.currentUrl];

          sessionStorage.setItem(this._routeKey, JSON.stringify(this._history));
        }
      });
  }

  getHistory(): string[] {
    return this._history;
  }
}
